export const VOLUNTEER_REGISTRATION_PREVIEW_SUCCESS = 'VOLUNTEER_REGISTRATION_PREVIEW_SUCCESS';
export const VOLUNTEER_REGISTRATION_PREVIEW_FAILURE = 'VOLUNTEER_REGISTRATION_PREVIEW_FAILURE';

